import React, { useEffect } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { Viewer } from '@react-pdf-viewer/core';
import { Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

const PDFViewer: React.FC<{ pdfFileRo: string, pdfFileRu: string }> = ({ pdfFileRo, pdfFileRu }) => {
    const { i18n: { language } } = useTranslation();
    const pdfFile = language === 'ro' ? pdfFileRo : pdfFileRu;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Container style={{padding: 0}} fixed>
            <Grid container  style={{margin: '40px 0'}}>
                <Grid item xs={12}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.15.349/build/pdf.worker.min.js">
                        <div
                            style={{
                                padding: '20px 0',
                                height: '750px',
                                boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
                            }}
                        >
                            <Viewer fileUrl={pdfFile} />
                        </div>
                    </Worker>                    
                </Grid> 
            </Grid>
        </Container>
    )
}

export default PDFViewer;